import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

const SriAgentScheduleListComponent = lazy(
  () => import("../../../../../components/sri-agent-schedule/components/list/page"),
);

const SriSyncLogComponent = lazy(
  () => import("../../../../../components/sri-agent-schedule/components/log/page"),
);

export const sriAgentScheduleRoute = [
  {
    path: "list",
    element: <SriAgentScheduleListComponent />,
  },
  {
    path: "log",
    element: <SriSyncLogComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/options/sri-agent-schedule/list" />,
  },
];
